import { render, staticRenderFns } from "./defectList.vue?vue&type=template&id=6df947c1&scoped=true"
import script from "./defectList.vue?vue&type=script&lang=js"
export * from "./defectList.vue?vue&type=script&lang=js"
import style0 from "./defectList.vue?vue&type=style&index=0&id=6df947c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df947c1",
  null
  
)

export default component.exports